<div class="lib-health">
  <div class="lib-health__icon" aria-hidden="true">
    <i class="ph ph-books"></i>
  </div>
  <div class="lib-health__content">
    <p class="lib-health__title">
      {{
        (variant === 'empty'
          ? 'tenders.responses.documents.library-health.empty-title'
          : 'tenders.responses.documents.library-health.low-title'
        ) | translate
      }}
    </p>
    <p class="lib-health__body">
      {{
        (variant === 'empty'
          ? 'tenders.responses.documents.library-health.empty-banner-before'
          : 'tenders.responses.documents.library-health.low-banner-before'
        ) | translate
      }}
      <button type="button" class="lib-health__link" (click)="goToLibrary.emit()">
        {{ 'tenders.responses.documents.library-health.library-link' | translate }}
      </button>
      {{
        (variant === 'empty'
          ? 'tenders.responses.documents.library-health.empty-banner-after'
          : 'tenders.responses.documents.library-health.low-banner-after'
        ) | translate
      }}
    </p>
  </div>
</div>
